(function () {
  const ROWS_TO_SHOW = 3;
  let userHasExpanded = false;

  function initSwatchCollapse() {
    document.querySelectorAll('[data-swatch-collapse]').forEach(function (grid) {
      if (grid.dataset.swatchInitialised) return;

      const wrapper = grid.closest('.linked-swatches__wrapper');
      if (!wrapper) return;

      const toggle = wrapper.querySelector('[data-swatch-toggle]');
      const label = toggle.querySelector('.linked-swatches__toggle-label');
      const items = Array.from(grid.querySelectorAll('.linked-swatch__input'));

      if (!items.length) return;

      const columns = window.innerWidth >= 750 ? 3 : 2;
      const totalRows = Math.ceil(items.length / columns);

      if (totalRows <= ROWS_TO_SHOW) {
        // Not enough rows for this viewport — hide toggle and remove collapse
        toggle.style.display = 'none';
        grid.classList.remove('is-collapsed');
        grid.dataset.swatchInitialised = 'true';
        return;
      }


      // Disable transition during re-init to prevent jump
      grid.style.transition = 'none';

      if (userHasExpanded) {
        grid.classList.remove('is-collapsed');
        label.textContent = 'Show less −';
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        label.textContent = 'Show all ' + items.length + ' colours ➔';
        toggle.setAttribute('aria-expanded', 'false');
      }

      // Re-enable transition after paint
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          grid.style.transition = '';
        });
      });

      grid.dataset.swatchInitialised = 'true';

      toggle.addEventListener('click', function () {
        const isCollapsed = grid.classList.contains('is-collapsed');
        if (isCollapsed) {
          grid.classList.remove('is-collapsed');
          label.textContent = 'Show less −';
          toggle.setAttribute('aria-expanded', 'true');
          userHasExpanded = true;
        } else {
          grid.classList.add('is-collapsed');
          label.textContent = 'Show all ' + items.length + ' colours ➔';
          toggle.setAttribute('aria-expanded', 'false');
          userHasExpanded = false;
        }
      });
    });
  }

  const observer = new MutationObserver(function () {
    const grids = document.querySelectorAll('[data-swatch-collapse]:not([data-swatch-initialised])');
    if (grids.length) {
      clearTimeout(window._swatchCollapseTimer);
      window._swatchCollapseTimer = requestAnimationFrame(initSwatchCollapse);
    }
  });


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(initSwatchCollapse);
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    requestAnimationFrame(initSwatchCollapse);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
